import React from 'react'

import AddSectionForm from '../../modules/Section/components/AddSectionForm'
export default function AddSectionPage() {
  return <AddSectionForm />
}
